<template>
    <div class="px-3 py-2">
        <v-form
            ref="forcar"
            lazy-validation
        >
            <b-sidebar v-model="visible" id="addContract" aria-labelledby="sidebar-no-header-title" no-header backdrop width="80rem" style="direction:ltr" right title="إضافة ملاحظة" shadow >
                <template #default="{ hide }">
                    <div class="m-1 text-start" style="direction:rtl">
                        <div style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                        <span>{{lang.add_contract}}</span>
                        </div>
                        <div @click="hide" id="hideContract" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                            <span>{{lang.close}}</span>
                        </div>
                    </div>
                <v-divider></v-divider>
                <b-alert v-if="saveError" show variant="danger" role="alert">{{saveError}}</b-alert>
                <v-row style="direction:rtl" class="m-2">
                    <v-col cols="12" sm="12" md="12" lg="12">
                        <div v-if="customer.id == 0 && $store.state.licenseType.showCustomerTypes" class="tobbuttom backBlack" :style="`direction:${ lang.dir};padding:7px;width:100%;text-align:center;`">
                            <b-button :style="`border-radius:0;background:transparent;color:#000;border:none;`">{{ lang.customer_type}}</b-button>
                            <b-button style="margin-inline-end:5px;font-weight: bolder;width:150px;font-size:1.1rem !important;margin-inline-end:5px;border:2px solid #fff !important" ref="_cInd" :class="['dispFlex btn btn-small','borderRad_'+lang.algin,Number(customer.customer_type) === 1 ? 'redColor' : 'weightColor']" @click="changeCusType(0)" >{{ lang.individual_client}} <i ref="_indiv" :class="{hideme:Number(customer.customer_type) !== 1}"  style="font-size:1.1rem !important;margin-inline-start:10px;" class="fas fa-arrow-down"></i></b-button>
                            <b-button style="margin-inline-end:5px;font-weight: bolder;width:150px;font-size:1.1rem !important;border:2px solid #fff !important" ref="_cCom" :class="['dispFlex btn btn-small borderRad_none',Number(customer.customer_type) === 2 ? 'redColor' : 'weightColor']" @click="changeCusType(1)" >{{ lang.company_clinet}} <i ref="_comps" :class="{hideme:Number(customer.customer_type) !== 2}"  style="font-size:1.1rem !important;margin-inline-start:10px;" class="fas fa-arrow-down"></i></b-button>
                            <b-button style="margin-inline-end:5px;font-weight: bolder;width:150px;font-size:1.1rem !important;border:2px solid #fff !important" ref="_cGov" :class="`dispFlex btn btn-small weightColor borderRad_`+lang.lalgin" @click="changeCusType(2)" >{{ lang.government_clinet}} <i ref="_goves" :class="{hideme:Number(customer.customer_type) !== 3}" style="font-size:1.1rem !important;margin-inline-start:10px;" class="fas fa-arrow-down"></i></b-button>
                        </div>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{lang.contract_date}}</label>
                        <div class="flexTay">
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="sd.day" :options="$store.state.daysList"/>
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="sd.month" :options="$store.state.monthsList" />
                            <b-form-select class="inborder text-center" style="width:60%;background:#efefef;" v-model="sd.year" :options="contractYears" />
                        </div>
                        <b-form-input class="inborder"
                            v-model="contract_date"
                            required
                            type="date"
                            style="display:none"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{lang.contract_expire_date}}</label>
                        <div class="flexTay">
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="ed.day" :options="$store.state.daysList"/>
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="ed.month" :options="$store.state.monthsList" />
                            <b-form-select class="inborder text-center" style="width:60%;background:#efefef;" v-model="ed.year" :options="contractYears" />
                        </div>
                        <b-form-input class="inborder"
                            v-model="expire_date"
                            required
                            type="date"
                            style="display:none;"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{lang.contract_start_date}}</label>
                        <div class="flexTay">
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="std.day" :options="$store.state.daysList"/>
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="std.month" :options="$store.state.monthsList" />
                            <b-form-select class="inborder text-center" style="width:60%;background:#efefef;" v-model="std.year" :options="contractYears" />
                        </div>
                        <b-form-input class="inborder"
                            v-model="start_date"
                            required
                            style="display:none;"
                            type="date"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{lang.mobile}}</label>
                        <b-form-input class="inborder"
                            v-model="mobile"
                            @change="getCustomer()"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12" style="display:none;">
                        <label>{{lang.company_name}}</label>
                        <b-form-input class="inborder"
                            v-model="company_name"
                            value=""
                            readonly
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="!showcamp && !showGov">
                        <label>{{lang.customer_name}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.full_name"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.company_name}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.company_name"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.crt_number}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.crt_number"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.vat_number}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.vat_number"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.building_no}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.building_no"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.street_name}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.street_name"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.district}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.district"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.city}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.city"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.zipcode}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.zipcode"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showcamp">
                        <label>{{lang.branch_number}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.branch_no"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12" v-if="showcamp">
                        <label>{{lang.address}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.address"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showGov">
                        <label>{{lang.entity_name}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.entity_name"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showGov">
                        <label>{{lang.branch_name}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.branch_name"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showGov">
                        <label>{{lang.po_number}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.po_number"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showGov">
                        <label>{{lang.po_date}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.po_date"
                            type="date"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="showGov">
                        <label>{{lang.request_number}}</label>
                        <b-form-input class="inborder"
                            v-model="customer.request_number"
                            value=""
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" v-if="con_type == 1">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="backBlack text-center" style="width:150px;">{{ lang.item_code }}</th>
                                    <th class="backBlack text-center">{{ lang.item_name }}</th>
                                    <th class="backBlack text-center" style="width:150px;">{{ lang.item_price }}</th>
                                    <th class="backBlack text-center" style="width:150px;">{{ lang.type }}</th>
                                    <th class="backBlack text-center">{{ lang.action }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in contract_items" :key="index">
                                    <td style="width:100px;">{{ item.item_code }}</td>
                                    <td>{{ item.item_name }}</td>
                                    <td style="width:150px;">{{ item.item_price }}</td>
                                    <td style="width:150px;">{{ item.type_name[`name_`+lang.langname] }}</td>
                                    <td style="cursor:pointer;margin-left: 5px;width:80px;background:red;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" style="background:red !important;" @click="deleteItem(index)" v-b-toggle.crm_project_view>{{lang.delete}}</div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th style="padding:2px !important;">
                                        <b-form-input class="inborder"
                                        v-model="new_itesm.item_code"
                                        @change="getItem()"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>{{ new_itesm.item_name }}</th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_itesm.item_price"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        {{ new_itesm.type_name[`name_`+lang.langname] }}
                                    </th>
                                    <td style="cursor:pointer;margin-left: 5px;width:80px;background:green;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" style="background:green !important;" @click="addNewItem()">{{lang.add}}</div>
                                    </td>
                                </tr>
                            </tfoot>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" v-if="con_type == 1">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="backBlack text-center">{{ lang.plate_number }}</th>
                                    <th class="backBlack text-center">{{ lang.brand_name }}</th>
                                    <th class="backBlack text-center">{{ lang.model }}</th>
                                    <th class="backBlack text-center">{{ lang.car_year }}</th>
                                    <th class="backBlack text-center">{{ lang.car_color }}</th>
                                    <th class="backBlack text-center">{{ lang.vin_number }}</th>
                                    <th class="backBlack text-center">{{ lang.meter_car }}</th>
                                    <th class="backBlack text-center">{{ lang.action }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in contracts_cars" :key="index">
                                    <td>{{ item.plate_number }}</td>
                                    <td>{{ item.brand }}</td>
                                    <td>{{ item.model }}</td>
                                    <td>{{ item.car_year }}</td>
                                    <td>{{ item.color }}</td>
                                    <td>{{ item.vin }}</td>
                                    <td>{{ item.meter_car }}</td>
                                    <td style="margin-left: 5px;width:80px;background:red;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" style="background:red !important;" @click="deleteCar(index)">{{lang.delete}}</div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>
                                        <div class="plateNumber p-2">
                                            <b-form-input class="inborder" @change="updatePlate()" v-model="new_cars.c1" style="width:30px;" />
                                            <b-form-input class="inborder" @change="updatePlate()" v-model="new_cars.c2" style="width:30px;border-right:none !important" />
                                            <b-form-input class="inborder" @change="updatePlate()" v-model="new_cars.c3" style="width:30px;border-right:none !important" />
                                            <b-form-input class="inborder" @change="updatePlate()" v-model="new_cars.text" style="width:60px;border-right:none !important" />
                                        </div>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.brand"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.model"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.car_year"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.color"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.vin"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <th>
                                        <b-form-input class="inborder"
                                        v-model="new_cars.meter_car"
                                        value=""
                                        ></b-form-input>
                                    </th>
                                    <td style="margin-left: 5px;width:80px;background:green;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" style="background:green !important;" @click="addCar()" v-b-toggle.crm_project_view>{{lang.add}}</div>
                                    </td>
                                </tr>
                            </tfoot>
                        </v-simple-table>
                    </v-col>
                    <v-col class="text-center" cols="12" md="6" sm="12" xs="12">
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="backBlack">{{ lang.add_title }}</th>
                                <th class="backBlack" style="width:80px;">{{ lang.action }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in titles" :key="index">
                                <td>{{ item }}</td>
                                <td class="text-center backRed" @click="delTitles(index)" style="cursor:pointer;">
                                    {{ lang.delete }}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th style="padding:2px !important;">
                                    <b-form-input class="inborder" v-model="title_text" />
                                </th>
                                <th @click="addTitles()" class="text-center backGreen" style="cursor:pointer;color:#fff;padding:3px !important;margin-top:3px;">
                                    {{ lang.add }}
                                </th>
                            </tr>
                        </tfoot>
                    </v-simple-table>
                </v-col>
                <v-col class="text-center" cols="12" md="6" sm="12" xs="12">
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="backBlack">{{ lang.terms }}</th>
                                <th class="backBlack">{{ lang.title_cond }}</th>
                                <th class="backBlack" style="width:80px;">{{ lang.action }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in terms" :key="index">
                                <td style="text-wrap: wrap;white-space: pre-line !important;text-align:start">{{ item.term }}</td>
                                <td style="width: 100px;text-wrap: wrap;white-space: pre-line !important;text-align:start">{{ item.title }}</td>
                                <td class="text-center backRed" @click="delTerms(index)" style="width: 50px;cursor:pointer;">
                                    {{ lang.delete }}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th style="padding:2px !important;">
                                    <b-form-textarea class="inborder" v-model="iterms"></b-form-textarea>
                                </th>
                                <th>
                                    <b-input-group>
                                        <b-form-select class="selborder" v-model="title" :options="titlesList" />
                                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                            <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </th>
                                <th @click="addTerms()" class="text-center backGreen" style="cursor:pointer;color:#fff;padding:3px !important;margin-top:3px;">
                                    {{ lang.add }}
                                </th>
                            </tr>
                        </tfoot>
                    </v-simple-table>
                </v-col>
                <v-col class="text-center" cols="12" md="6" sm="12" xs="12">
                    <b-table-simple>
                        <thead>
                            <tr>
                                <th style="padding:2px !important;" colspan="1" class="backBlack text-center">{{ lang.add_attachement }}</th>
                                <th style="padding:2px !important;" colspan="2" class="backBlack text-center">
                                    <input
                                          type="file"
                                          multiple
                                          label="lang.choose_file"
                                          style="width:98%;border:1px solid #ccc;padding:5px;color:red"
                                          ref="attached"
                                          class="inborder"
                                          @change="selectFiles()"
                                          >
                                </th>
                            </tr>
                            <tr>
                                <th style="padding:2px !important;width:120px;" class="backBlack">
                                    {{ lang.file_size }}
                                </th>
                                <th style="padding:2px !important;" class="backBlack">{{ lang.file_name }}</th>
                                <th style="padding:2px !important;width:75px;" class="backBlack">{{ lang.action }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(attach,index) in attached" :key="index">
                                <td>{{ $RoundNums(parseFloat(parseFloat(attach.size)/1024)/1024,2) }} MB</td>
                                <td>{{ attach.name }}</td>
                                <td><i @click.prevent="attached.splice(index,1)" class="fas fa-trash-alt m-2" style="float:left;"></i></td>
                            </tr>
                        </tbody>
                        <tfoot>

                        </tfoot>
                    </b-table-simple>
                </v-col>
                </v-row>
                </template>
                <template #footer="" class="shadow">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                    <b-button type="button" @click="AddContract()" :disabled="saving || locked" variant="success" class="ma-2" style="width:100px;">{{lang.add}}</b-button>
                    </div>
                </template>
            </b-sidebar>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify'
export default{
    data() {
        return {
            visible: false, saving: false, locked: false, saveError: '', draftSerial: 0, customerLookupSerial: 0,
            customer: {
                id: 0,
                cctype: 1,
                customer_type: 1,
                full_name: '',
                company_name: '',
                crt_number: '',
                vat_number: '',
                building_no: '',
                street_number: '',
                district: '',
                city: '',
                zipcode: '',
                branch_no: '',
                address: '',
                entity_name: '',
                branch_name: '',
                po_number: '',
                po_date: '',
                request_number: ''
            },
            showcamp: false,
            showGov: false,
            titles: [],
            id: 0,
            mobile: '',
            company_name: '',
            contract_items: [],
            new_itesm: {
                item_code: '',
                item_name: '',
                item_price: '',
                type: '',
                type_name: []
            },
            contracts_cars: [],
            new_cars: {
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number: '',
                brand: '',
                model: '',
                car_year: '',
                color: '',
                vin: '',
                meter_car: '',
            },
            title: 0,
            terms: [],
            iterms: '',
            attached: [],
            title_text: '',
            con_type: 1,
            sd: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            },
            ed: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear() + 1,
            },
            std: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            },
            customersList: []
        }
    },
    computed: {
        contractYears(){
            const current = new Date().getFullYear();
            const selected = [this.sd.year,this.std.year,this.ed.year].map(Number).filter(year => Number.isInteger(year) && year >= 1000 && year <= 9999);
            const first = Math.min(current - 5,...selected), last = Math.max(current + 20,...selected);
            return Array.from({length:last-first+1},(_,index) => ({value:first+index,text:String(first+index)}));
        },
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        contract_date: function(){
            return  `${this.sd.year}-${('0'+this.sd.month).slice(-2)}-${('0'+this.sd.day).slice(-2)}`;
        },
        expire_date: function(){
            return  `${this.ed.year}-${('0'+this.ed.month).slice(-2)}-${('0'+this.ed.day).slice(-2)}`;
        },
        start_date: function(){
            return  `${this.std.year}-${('0'+this.std.month).slice(-2)}-${('0'+this.std.day).slice(-2)}`;
        },
        titlesList: function(){
            let t = [];
            for(let i=0;i<this.titles.length;i++){
                t.push({
                    text: this.titles[i],
                    value: i
                })
            }
            return t;
        },
        responses: function(){
            let t = [];
            for(let i=0;i < this.users.length;i++){
                t.push(
                    {text: this.users[i].full_name, value: this.users[i].id}
                )
            }
            return t;
        },
        taskStatus: function(){
            let t = [];
            for(let i=0;i < this.statuss.length;i++){
                let text = this.lang.langname == 'ar' ? this.statuss[i].name_ar : this.statuss[i].name_en;
                t.push(
                    {text: text, value: this.statuss[i].value}
                )
            }
            return t;
        }
    },
    methods: {
        changeCusType(id){
            const type = Number(id) + 1;
            if(![1,2,3].includes(type)) return false;
            this.customer.cctype = type;
            this.customer.customer_type = type;
            this.showcamp = type === 2;
            this.showGov = type === 3;
            this.customersList = [];
            return true;
        },
        updatePlate(){
            this.new_cars.plate_number = this.new_cars.c1 + " " + this.new_cars.c2 + " " + this.new_cars.c3 + " " + this.new_cars.text
            this.getCar();
        },
        selectFiles(){
            const files = this.$refs.attached.files;
            this.attached = [...this.attached, ...files];
        },
        addTitles(){
            if(this.title_text == '') return false;
            this.titles.push(this.title_text);
            this.title_text = ''
        },
        delTitles(index){
            this.titles.splice(index,1)
        },
        addTerms(){
            console.log(this.iterms)
            if(this.iterms == '') return false;
            this.terms.push({
                term: this.iterms,
                title: this.titles[this.title],
                title_id: this.title
            });
            this.iterms = ''
            this.title = 0
        },
        delTerms(index){
            this.terms.splice(index,1)
        },
        resetAll(id){
            if(this.saving) return false;
            this.draftSerial++; this.customerLookupSerial++; this.locked = false; this.saveError = "";
            const now = new Date();
            this.sd = {year:now.getFullYear(),month:now.getMonth()+1,day:now.getDate()};
            this.std = {...this.sd}; this.ed = {...this.sd,year:now.getFullYear()+1};
            this.showcamp = false; this.showGov = false;
            this.con_type = id;
            this.id =  0;
            // this.contract_date =   (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            // this.start_date =   (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            // this.expire_date =   (new Date(new Date(new Date().setFullYear(new Date().getFullYear() + 1)) - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            this.mobile =  '';
            this.company_name =  '';
            this.contract_items =  [];
            this.new_itesm =  {
                item_code:   '',
                item_name:   '',
                item_price:   '',
                type:   '',
                type_name:   []
            };
            this.contracts_cars = [];
            this.new_cars =  {
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number:   '',
                brand:   '',
                model:   '',
                car_year:   '',
                color:   '',
                vin:   '',
                meter_car:   '',
            };
            this.title = 0
            this.titles = []
            this.terms = []
            this.iterms = ''
            this.attached = []
            this.title_text = ''
            this.customer = {
                id: 0,
                cctype: 1,
                customer_type: 1,
                full_name: '',
                company_name: '',
                crt_number: '',
                vat_number: '',
                building_no: '',
                street_number: '',
                district: '',
                city: '',
                zipcode: '',
                branch_no: '',
                address: '',
                entity_name: '',
                branch_name: '',
                po_number: '',
                po_date: '',
                request_number: ''
            }
        },
        loadForEdit(contract){
            if(this.saving) return false;
            if(!contract || contract.is_locked || contract.can_edit === false){
                this.$snotify.error(this.contractMessage('contract_used_locked'), this.lang.alert);
                return false;
            }
            if(!contract.customer || Number(contract.customer.id) !== Number(contract.customerid)){
                this.$snotify.error(this.contractMessage('contract_input_invalid'), this.lang.alert);
                return false;
            }
            this.resetAll(contract.con_type);
            this.id = Number(contract.contract_id);
            this.con_type = Number(contract.con_type);
            const parseDate = (str, target) => {
                const parts = String(str || '').split('-').map(Number);
                if(parts.length === 3){target.year = parts[0]; target.month = parts[1]; target.day = parts[2];}
            };
            parseDate(contract.contract_date, this.sd);
            parseDate(contract.start_date, this.std);
            parseDate(contract.expire_date, this.ed);
            this.customer = {...this.customer, ...contract.customer,
                vat_number: contract.customer.company_vatid || '',
                branch_no: contract.customer.branch_number || '',
                street_number: contract.customer.street_name || '',
                po_number: contract.po_number || '',po_date: contract.po_date || '',request_number: contract.request_number || ''};
            this.mobile = (contract.customer_contacts && contract.customer_contacts[0]) ? contract.customer_contacts[0].mobile : '';
            this.$nextTick(() => this.changeCusType(Number(this.customer.customer_type) - 1, false));
            this.visible = true;
            this.contract_items = (contract.contract_items || []).map((it) => ({
                item_code: it.item_code,
                item_name: it.item_name,
                item_price: it.item_price,
                type: it.type,
                type_name: Number(it.type) === 1 ? {name_ar:'مخزون',name_en:'Inventory'} : {name_ar:'خدمات',name_en:'Services'},
            }));

            this.contracts_cars = (contract.cars || []).filter((c) => c && c.id).map((c) => ({
                c1: '', c2: '', c3: '',
                text: c.plate_number,
                plate_number: c.plate_number,
                brand: c.brand,
                model: c.model,
                car_year: c.manufacturing_year,
                color: c.color,
                vin: c.vin,
                meter_car: c.meter_car || '',
            }));

            // titles/terms use a client-side index scheme (a term's title_id
            // is an INDEX into the titles array, not a real DB id -- see
            // addTerms()/titlesList above), so rebuild both from
            // contract_terms_titles' already-grouped shape in one pass to
            // keep the indexes consistent.
            this.titles = [];
            this.terms = [];
            (contract.contract_terms_titles || []).forEach((t, idx) => {
                this.titles.push(t.title_name);
                (t.terms || []).forEach((term) => {
                    this.terms.push({
                        term: term.terms,
                        title: t.title_name,
                        title_id: idx,
                    });
                });
            });
        },
        deleteCar(index) {
            this.contracts_cars.splice(index,1)
        },
        deleteItem(index) {
            this.contract_items.splice(index,1)
        },
        async getCustomer(){
            if(this.id || this.saving) return false;
            const serial = ++this.customerLookupSerial, mobile = this.mobile;
            const post = new FormData();
            post.append('type','getCustomerMob');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[mobile]',mobile);
            try {
                const response = await axios.post(this.$SAMCOTEC.r_path,post);
                if(serial !== this.customerLookupSerial || mobile !== this.mobile || this.id) return false;
                const found = response.data && response.data.results && response.data.results.data;
                if(Number(response.data.error && response.data.error.number) === 200 && found && Number(found.id) > 0){
                    this.customer = {...this.customer,...found,vat_number: found.company_vatid || found.vat_number || '',branch_no: found.branch_number || found.branch_no || ''};
                    this.changeCusType(Number(found.customer_type) - 1, false);
                    return true;
                }
                this.customer.id = 0;
            } catch(error){
                if(serial === this.customerLookupSerial) this.saveError = this.contractMessage('contract_customer_lookup_failed');
            }
            return false;
        },
        getItem(){
            const post = new FormData();
            post.append("type" , "getItemProd");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[item_code]",this.new_itesm.item_code);
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then((response) => {
                if(response && response.data && response.data.results && response.data.results.data.item_name != ''){
                    this.new_itesm =  {
                        item_code: response.data.results.data.item_code,
                        item_name: response.data.results.data.item_name,
                        item_price: response.data.results.data.item_price,
                        type: response.data.results.data.type,
                        type_name: response.data.results.data.type_name
                    }
                }else{
                    let message = 'الصنف غير موجود يرجى اضافة الصنف عن طريق قائمة المخزون من ثم اصناف المخزون';
                    this.$snotify.error(message, 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.$parent.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    return false;
                }
            })
        },
        getCar(){
            const post = new FormData();
            post.append("type" , "getCar");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[plate_number]",this.new_cars.plate_number);
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then((response) => {
                if(response && response.data && response.data.results){
                    let car = response.data.results.data.plate_number.split(" ")
                    this.new_cars =  {
                        c1: car[0],
                        c2:car[1],
                        c3: car[2],
                        text: car[3],
                        plate_number: response.data.results.data.plate_number,
                        brand: response.data.results.data.brand,
                        model: response.data.results.data.model,
                        car_year: response.data.results.data.car_year,
                        color: response.data.results.data.color,
                        vin: response.data.results.data.vin,
                        meter_car: '',
                    }
                }
            })
        },
        addCar(){
            let tr = true;
            Object.keys(this.new_cars).forEach(key => {
                if(key == 'vin' || key == 'meter_car'){
                    //
                }
                else if(this.new_cars[key] == ''){
                    tr = false;
                }
            })
            if(!tr){
                let message = 'يرجى اكمال بيانات السيارة حتى تستطيع المتابعة';
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            this.contracts_cars.push(this.new_cars);
            this.new_cars =  {
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number: '',
                brand: '',
                model: '',
                car_year: '',
                color: '',
                vin: '',
                meter_car: '',
            }
        },
        addNewItem(){
            let tr = true;
            Object.keys(this.new_itesm).forEach(key => {
                if(key == 'type' || key == 'type_name'){
                    //
                }
                else if(this.new_itesm[key] == ''){
                    tr = false;
                }
            })
            if(!tr){
                if(this.id == 0){
                    let message = 'يرجى اكمال بيانات الصنف حتى تستطيع المتابعة';
                    this.$snotify.error(message, 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.$parent.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    return false;
                }
            }

            this.contract_items.push(this.new_itesm);
            this.new_itesm =  {
                item_code: '',
                item_name: '',
                item_price: '',
                type: '',
                type_name: []
            }
        },
        getUsers(){
            const post = new FormData();
            post.append("type" , "getUsers");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[crm_id]",this.crm_id);
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then((response) => {
                // console.log(response.data)
                if(response && response.data && response.data.results){
                    this.users = response.data.results.data.results
                }
            })
        },
        getStatics(){
            const post = new FormData();
            post.append("type" , "getStaticOptions");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[phrase]",'taskStatus');
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then((response) => {
                // console.log(response.data)
                if(response && response.data && response.data.results){
                    this.statuss = response.data.results.data
                }
            })
        },
        contractMessage(code){
            const messages = {
                contract_used_locked: ['هذا العقد مرتبط ببطاقة عمل أو فاتورة ولا يمكن تعديله. أنشئ عقداً جديداً للتغييرات.', 'This contract has linked job cards or invoices and is locked. Create a new contract for changes.'],
                contract_reference_fields_unavailable: ['تعذر حفظ مراجع العقد. تواصل مع مسؤول النظام لتفعيلها أولاً.', 'Contract references cannot be saved yet. Contact your administrator to enable them.'],
                contract_attachments_unavailable: ['مرفقات العقود غير مدعومة حالياً. احتفظ بالملفات واحذفها من هذه المسودة قبل الحفظ.', 'Contract attachments are currently unavailable. Keep your files and remove them from this draft before saving.'],
                contract_customer_exists_select: ['رقم الاتصال مرتبط بعميل موجود. اختر العميل الموجود أولاً.', 'This phone belongs to an existing customer. Select that customer first.'],
                contract_customer_lookup_failed: ['تعذر البحث عن العميل. أعد المحاولة قبل الحفظ.', 'Customer lookup failed. Try again before saving.'],
                start_date_after_expire_date: ['تاريخ البدء يجب ألا يتجاوز تاريخ الانتهاء.', 'Start date must not be after expiry.'],
                contract_items_cars_required: ['أضف الأصناف والسيارات إلى عقد الصيانة.', 'Add covered items and vehicles to the maintenance contract.'],
                contract_input_invalid: ['تحقق من بيانات العقد والعميل والأصناف والسيارات.', 'Check the contract, customer, item and vehicle details.'],
                contract_write_failed: ['تعذر تأكيد حفظ العقد. بقيت المسودة مفتوحة. تحقق من القائمة قبل إعادة المحاولة.', 'The contract save could not be confirmed. Your draft is still open. Check the list before retrying.']
            };
            return (messages[code] || messages.contract_write_failed)[this.lang.dir === 'rtl' ? 0 : 1];
        },
        async AddContract(){
            if(this.saving || this.locked) return false;
            this.saveError = '';
            if(this.start_date > this.expire_date){this.saveError = this.contractMessage('start_date_after_expire_date'); return false;}
            if(Number(this.con_type) === 1 && (!this.contract_items.length || !this.contracts_cars.length)){
                this.saveError = this.contractMessage('contract_items_cars_required'); return false;
            }
            if(this.attached.length){this.saveError = this.contractMessage('contract_attachments_unavailable'); return false;}
            this.saving = true;
            const serial = this.draftSerial, id = Number(this.id);
            const post = new FormData();
            post.append('type','addNewContract');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            for(const [key,value] of Object.entries({id,mobile:this.mobile,contract_date:this.contract_date,start_date:this.start_date,expire_date:this.expire_date,con_type:this.con_type,customer:JSON.stringify(this.customer),titles:JSON.stringify(this.titles),terms:JSON.stringify(this.terms)})) post.append('data['+key+']',value);
            for(const [key,rows] of Object.entries({items:this.contract_items,cars:this.contracts_cars})) rows.forEach((row,i) => {
                for(const [field,value] of Object.entries(row)) if(field !== 'type_name') post.append('data['+key+']['+i+']['+field+']',value == null ? '' : value);
            });
            try {
                const response = await axios.post(this.$store.state.SAMCOTEC.r_path,post);
                const body = response.data, saved = body && body.results && body.results.data;
                if(!body || Number(body.error && body.error.number) !== 200 || !saved || saved.saved !== true || !Number.isInteger(Number(saved.contract_id)) || Number(saved.contract_id) < 1 || (id && Number(saved.contract_id) !== id)){
                    const failure = new Error('contract_write_failed'); failure.response = {data:body}; throw failure;
                }
                if(serial !== this.draftSerial) return true;
                this.id = Number(saved.contract_id);
                this.visible = false;
                this.$snotify.success(this.$parent.lang.addes_successfuly,this.$parent.lang.alert);
                this.$parent.getContracts();
                return true;
            } catch(error){
                if(serial === this.draftSerial){
                    const code = error.response && error.response.data && error.response.data.error && error.response.data.error.code;
                    this.locked = code === 'contract_used_locked';
                    this.saveError = this.contractMessage(code || 'contract_write_failed');
                }
                return false;
            } finally {this.saving = false;}
        }

    },
    created() {
        this.getUsers();
        this.getStatics();
    },
}
</script>
<style scoped>
.flexTay{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    justify-items: center;
}
.flexTay select{
    margin-inline-end: 2px;
}
.hideme{
    display:none !important;
}
.redColor {
    background: red!important;
    color: #fff!important;
}
.weightColor {
    background: #fff !important;
    color: #000 !important;
}
</style>